import React from "react";
import { Button } from "react-bootstrap";
import Card from 'react-bootstrap/Card';
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { deletePostSub, deletePost, deletePostId, deletePostDay } from "../store"

function LocalsPost() {

    let getLogin = sessionStorage.getItem('login')

    let dispatch = useDispatch()
    let rStore = useSelector((state)=>{return state})
    let navigate = useNavigate()
    let writed = localStorage.getItem('writed')
    let Lpost = JSON.parse(writed)   
    let writedarray = JSON.parse(writed)

    if (getLogin) {        
  
    return(
        
            <div style={{backgroundColor:'', height:'1200px'}}> 
            <span></span>  
                {Lpost.map(function(a,i){
                    return(
                        <div>
                             <Card style={{marginBottom:'20px'}}>
                             <Card.Header
                                onClick={()=>{navigate('/detail/'+i)}}
                             >{Lpost[i][1]}</Card.Header>
                                <Card.Body>
                                <blockquote className="blockquote mb-0">
                                 <p>
                                 {Lpost[i][2]}
                                   {/* {rStore.postId[i]} */}
                                </p>                               
                               <div style={{float:'right'}}>
                               <span style={{fontSize:13, marginRight:'15px', color:'gray'}}>{Lpost[i][3]}</span>
                                <Button variant="light" onClick={()=>{
                                    // edit로 i를 전해주면
                                    // edit에서 i값으로 배열에 해당하는 값을 불러와
                                    // 내용을 수정할 수 있게 input에 할당해준다.
                                    navigate('/edit',{state:i})
                                }}
                                style={{marginRight:'15px'}}
                                >수정</Button>
                                <Button variant="danger" onClick={()=>{
                                    // Redux값을 삭제하라
                                    dispatch(deletePostSub(i))
                                    dispatch(deletePost(i))
                                    dispatch(deletePostId(i))
                                    dispatch(deletePostDay(i))
                                    console.log('삭제버튼 눌렀음',i)

                                    // 로컬스토리지값을 삭제하라
                                    writedarray.splice([i][0],1)
                                    console.log('삭제된 후의 값',localStorage.getItem('writed'))
                                    localStorage.setItem('writed',JSON.stringify(writedarray))
                                    navigate('/')

                                }}>삭제</Button>
                                </div>
                                </blockquote>
                    </Card.Body>
                 </Card>


                        </div>
                    )
                })

               
            }
        



            </div>

    )
    } else {
              return(     <div>로그인안함</div> )
    }
}

export default LocalsPost